export default __webpack_public_path__ + "static/media/261756.b533f317.jpg";